import type { Property } from '@protector/entities/property/models';
import type { Season } from '@protector/entities/season/models';

export const SeasonActionsTypes = {
  SET_SEASONS_FROM_PROPERTY: '[Season] Set seasons from property',
  SET_SEASONS_FROM_PROPERTIES: '[Season] Set seasons from properties',
  LOAD_SEASONS_SUCCESS: '[Season] Load Seasons Success'
} as const;

export const SetSeasonsFromProperties = (properties: Property[]) => {
  return {
    type: SeasonActionsTypes.SET_SEASONS_FROM_PROPERTIES,
    payload: properties
  };
};

export const SetSeasonsFromProperty = () => {
  return {
    type: SeasonActionsTypes.SET_SEASONS_FROM_PROPERTY
  };
};

export const LoadSeasonsSuccess = (seasons: Season[]) => {
  return {
    type: SeasonActionsTypes.LOAD_SEASONS_SUCCESS,
    payload: seasons
  };
};
